import React,{ useState,useLayoutEffect } from 'react'


const SubmenuList = (props) => {

   const { subMenuList } = props;

   const withOutArrowId = ["vmware","vxrailhci","dm","dataprotection"];


   return (

      <div className='accordionContent'>
         {((window.mob || (window.isipad && window.innerHeight > window.innerWidth)) && props.orentation == 0) ? <div className='accordionCallout'></div> : ''}
         {/* {additionalHeadingText ? <p>{additionalHeadingText}</p>:null} */}
         <ul className='subMenu'>
            {
               // <ol className='mobDisclaimer' style={{ display: 'none' }}>
               //    <li>Based on Dell analysis of cybersecurity software capabilities; flexibility-related features including functional, operational, and hardware flexibility;
               //       and efficiency-related features including data reduction, storage capacity, data protection overhead, hardware, rack units, lifecycle management, and ENERGY STAR certified
               //       configuration, Jun. 2024.</li>
               //    <li>Based on Dell analysis, March 2024.</li>
               // </ol>

               <ol className='mobDisclaimer' style={{ display: 'none' }}>
                  <li></li>
                  <li></li>
               </ol>
            }
            {
               subMenuList.map((list) => {
                  return (
                     <li key={Math.random()} tabIndex={-1} defaultChecked={true} className={`subMenuBtn ${list.menuType}`} id={`menu_id_${list.id}`} onKeyDown={(e) => {
                        if (e.key !== 'Enter') {
                           return
                        } props.handleMenuClick(list)
                     }} onClick={(event) => {
                        props.handleMenuClick(list,event)
                     }} >
                        {list.menuType === "radioButton" ? <label>
                           <input type={'radio'} value={'product1'} name={list.selectConfiguration} />
                           <span id="tower_tab">  {list.title}</span>
                        </label>
                           : ((window.mob || window.innerHeight > window.innerWidth) && props.orentation === 0) || window.innerWidth < 935 ?
                              <>
                                 {!withOutArrowId.includes(list.id) && (
                                    <div className='accordia_icon'>
                                       <img className='arrow' src='images/spacer.png' id={`accordianIcon_${list.id}`} />
                                    </div>
                                 )}
                                 {list.title}
                              </>
                              : list.title}

                     </li>
                  )
               })
            }

         </ul>
      </div>
   )
}

export default SubmenuList